import React from "react";
import NewsUpdates from "../Home/components/news_update";
import MultipleItems3 from "../Home/components/top_agent";
import TopUniversities from "../Home/components/top_university";
import Header from "../Layout/Header";
import Agent_detail from "./component/agents_detail";
import Breadcrumbs from "./component/breadcrumbs";
import Courses_detail from "./component/courses_detail";
import Slider_listing from "./component/lising_detail_slider";
import Map_detail from "./component/listing_map";
import University_detail from "./component/university_detail";
import University_logo from "./component/university_logo";



function Listing_detail() {
    return (
        <div className="top-space">
            <div className="listing_detail">
                <Breadcrumbs />
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <Slider_listing />
                        </div>
                    </div>
                </div>
            </div>
            <div className="background">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <University_logo />
                        </div>
                    </div>
                </div>
            </div>
            <div className="university_courses_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="penn_state_university_wrap">
                                 <div className="left_wrap">
                                    <University_detail />
                                    < Agent_detail />
                                 </div>
                                 <div className="right_area">
                                     <Map_detail  />
                                    <Courses_detail />
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Listing_detail;
